import React from 'react'

import { DefaultLayoutComponent } from './layout'

import { DataWarehouse } from '../components/DataWarehouse'


export const DataWarehouseScreen = (): JSX.Element => {
  return (
    <DefaultLayoutComponent>
      <DataWarehouse />
    </DefaultLayoutComponent>
  )
}

export default DataWarehouseScreen
